"use client";
import { TextAttr, LinkAttr, IconAttr, RepeaterAttr } from "@/core/blocks/attributes";
import { useBlock } from "@/core/blocks/context";
import type { ComponentType } from "react";
import * as moduleClient from "@cms/module-api/client";

// CMS cores before module API 1.9.0 have no CookieSettingsLink; the footer then
// simply shows no link instead of failing the build.
const CookieSettingsLink = (moduleClient as Record<string, unknown>).CookieSettingsLink as ComponentType<{ locale?: string }> | undefined;

/** Theme footer. The logo is part of the theme itself (not an attribute). */
export function Footer() {
  const { locale } = useBlock();
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-about">
          {/* Hardcoded theme logo */}
          <svg className="footer-logo" viewBox="0 0 32 32" aria-hidden="true">
            <rect x="2" y="2" width="28" height="28" rx="8" fill="currentColor" opacity="0.15" />
            <path d="M9 22V10h6.2a4.3 4.3 0 0 1 0 8.6H13V22H9Zm4-7h2a1.5 1.5 0 0 0 0-3h-2v3Z" fill="currentColor" />
            <circle cx="22.5" cy="20" r="2.5" fill="currentColor" />
          </svg>
          <TextAttr name="intro" rich as="p" className="footer-intro" placeholder={{ nl: "Korte introductie…", en: "Short introduction…" }} />
          <RepeaterAttr name="socials" as="div" className="footer-socials" addLabel={{ nl: "Social", en: "Social" }} itemDefaults={() => ({ icon: "social:linkedin" })}>
            {() => (
              <LinkAttr name="link" className="footer-social">
                <IconAttr name="icon" />
              </LinkAttr>
            )}
          </RepeaterAttr>
        </div>
        <nav className="footer-col" aria-label="Footer menu 1">
          <TextAttr name="menu1Title" as="h4" placeholder={{ nl: "Menutitel", en: "Menu title" }} />
          <RepeaterAttr name="menu1" as="ul" addLabel={{ nl: "Link", en: "Link" }} itemDefaults={() => ({})}>
            {() => (
              <li>
                <LinkAttr name="link">
                  <TextAttr name="label" placeholder={{ nl: "Link", en: "Link" }} />
                </LinkAttr>
              </li>
            )}
          </RepeaterAttr>
        </nav>
        <nav className="footer-col" aria-label="Footer menu 2">
          <TextAttr name="menu2Title" as="h4" placeholder={{ nl: "Menutitel", en: "Menu title" }} />
          <RepeaterAttr name="menu2" as="ul" addLabel={{ nl: "Link", en: "Link" }} itemDefaults={() => ({})}>
            {() => (
              <li>
                <LinkAttr name="link">
                  <TextAttr name="label" placeholder={{ nl: "Link", en: "Link" }} />
                </LinkAttr>
              </li>
            )}
          </RepeaterAttr>
        </nav>
      </div>
      <div className="container footer-copy">
        {/* The year is always current and never editable; the name next to it is. */}
        <span>© {new Date().getFullYear()}</span>{" "}
        <TextAttr name="copyrightName" as="span" placeholder={{ nl: "Sitenaam", en: "Site name" }} />
        {/* Visitors must be able to change or withdraw their cookie choice on every page (AP). */}
        {CookieSettingsLink && <>{" · "}<CookieSettingsLink locale={locale} /></>}
      </div>
    </footer>
  );
}
